import treemap from 'daisy-chart/src/layouts/treemap';
import data from './data/big_city.json';

treemap().data(data)
  .name('treemap')
  .container('#daisy-example')
  .width(740).height(540)
  .dimensions(['대륙', '국가'])
  .measures(['지방자치단체 수 (개수)'])
  .legend(true)
  .sortByValue('ascending')
  .render();


// WEBPACK FOOTER //
// ./js/examples/monoTreeMap.js